import { render, staticRenderFns } from "./InsurerCodeAndType.vue?vue&type=template&id=2b082489&scoped=true"
import script from "./InsurerCodeAndType.vue?vue&type=script&lang=js"
export * from "./InsurerCodeAndType.vue?vue&type=script&lang=js"
import style0 from "./InsurerCodeAndType.vue?vue&type=style&index=0&id=2b082489&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b082489",
  null
  
)

export default component.exports